import React from 'react';
import { FormControl, FormHelperText, FormLabel, Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import { InstantClientSelect } from '@/components/selects/ClientSelect';
import { InstantDealSelect } from '@/components/selects/DealSelect';

export const AssociatedClientDealSelect = ({
	gridSize = 12,
	clientId,
	clientDisabled = false,
	dealDisabled = false,
	onClientChange,
	onDealChange,
}) => {
	const { values, touched, errors, getFieldProps } = useFormikContext();
	const resolvedClientId = clientId ?? values.client?.clientId;
	const clientError = Boolean(touched.id && errors.id);

	return (
		<>
			<Grid size={gridSize}>
				<FormControl
					required={Object.hasOwn(values, 'id')}
					error={clientError}
					sx={{ width: '100%' }}
					{...(Object.hasOwn(values, 'id') && getFieldProps('id'))}
				>
					<FormLabel>Associated client</FormLabel>
					<InstantClientSelect
						clientId={resolvedClientId}
						clientName={values.client?.name}
						disabled={clientDisabled}
						showContact={false}
						error={clientError}
						width={'100%'}
						setClient={onClientChange}
					/>
					{clientError && <FormHelperText error>{errors.id}</FormHelperText>}
				</FormControl>
			</Grid>
			<Grid size={gridSize}>
				<FormControl sx={{ width: '100%' }}>
					<FormLabel>Associated deal or claim</FormLabel>
					<InstantDealSelect
						disabled={dealDisabled}
						clientId={resolvedClientId}
						dealId={values.deal?.dealId}
						dealName={values.deal?.dealName}
						setDeal={onDealChange}
						autoPopulate={true}
					/>
				</FormControl>
			</Grid>
		</>
	);
};
